export const TORONTO_TIMEZONE = 'America/Toronto'

export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ' // ISO 8601 with timezone offset
export const DISPLAY_DATETIME_FORMAT = 'DD-MM-YYYY [às] HH:mm' // For UI display
export const DISPLAY_FULL_DATE_FORMAT = 'D [de] MMMM [de] YYYY'
export const DISPLAY_DATE_FORMAT = 'DD-MM-YYYY'
export const DISPLAY_TIME_FORMAT = 'HH:mm'
